// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburg2DE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2",
  seo: {
    title: "NEXT GENERATION - Abschluss unserer Auszubildenden 2018 | Dietz GmbH",
    description: "NEXT GENERATION - Abschluss unserer Auszubildenden 2018",
  },
  type: "post",
  h1: "NEXT GENERATION - Abschluss unserer Auszubildenden 2018",
  blocks: [
    { kind: "heading", level: 2, text: "NEXT GENERATION – Abschluss unserer Auszubildenden 2018" },
    { kind: "paragraph", text: "Die hervorragende Ausbildung der nächsten Generation ist und bleibt eines der Themen, die uns am meisten am Herzen liegen. Deshalb freuen wir uns auch ganz besonders darüber, dass im Februar gleich vier Lehrlinge die Prüfung zum Werkzeugmechaniker erfolgreich bestanden haben. Emily Knauer, Matthias Seifert, Julian Müller und Joshua Packert bleiben nach bestandener Prüfung unserem Unternehmen treu und kommen nun in der Federnabteilung und im Werkzeugbau zum Einsatz. Ganz besonders stolz kann Joshua Packert auf das Erreichte sein: Mit einem Notendurchschnitt von 1,5 wurde der Ex-Azubi von der IHK ausgezeichnet." },
    { kind: "paragraph", text: "Unsere Azubis im 4. Ausbildungsjahr (von links nach rechts): Matthias Seifert, Julian Müller, Joshua Packert und Emily Knauer." }
  ],
};
